// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"201":"component---src-gatsby-entities-page-tsx","336":"component---node-modules-shapeable-gatsby-theme-shapeable-web-src-components-404-tsx","542":"component---src-gatsby-entities-post-tsx"}[chunkId] + "-" + {"201":"c98b63f56859e23faae2","336":"edc32e1cdc683fdcc96f","542":"8796dac2581cc9812014"}[chunkId] + ".js";
};